<template>
  <v-row class="ma-4 mpc-location mx-auto">
    <v-col class="pa-0">
      <v-img src="@/assets/illustrations/map_pin.svg" height="44px" width="44px" class="mx-auto"/>
      <div class="token-text-h4 mb-2 text-center">
        Location
      </div>
      <div class="token-text-regular mb-6 text-center">
        Almost done, do you need to be hosted in a specific country?
      </div>
      <div class="card">
        <CountrySelector @select="onCountrySelect"/>
        <div class="token-text-medium token-text-color-brand mt-4 text-center cursor-pointer text-decoration-underline"
          @click="$emit('update:selectedCountry', null)"
        >
          No, I don’t need a specific country
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { Vue, Options, prop } from 'vue-class-component'

import CountrySelector from '@/components/UIElements/CountrySelector.vue'
import { ListItem } from '@/components/UIElements/List.vue';

class Props {
  selectedCountry?: ListItem = prop({
    required: false,
  });
}


@Options({
  components: {
    CountrySelector
  },
})
export default class MPCLocation extends Vue.with(Props) {
  onCountrySelect(selectedCountry: ListItem): void {
    this.$emit('update:selectedCountry', selectedCountry);
  }
}
</script>
<style lang="scss" scoped >
@import '@/css/variables';
.mpc-location {
  width: calc(100% - 16px);
}
</style>